import { HighlightedRow } from "api/other/models";
import { UUID } from "api/types";
import { InvoicePagination } from "components/common/invoicePagination/InvoicePagination";
import { CommonError, RightPanelHandler } from "components/utils";
import { RightPanel } from "./rightPanel/RightPanel";
import { ListDrawerWrapper } from "components/utils/drawer";
import { Loader } from "components/utils/loader";
import { ModuleList } from "components/utils/moduleList";
import { ModuleListBody } from "components/utils/moduleList/components/ModuleListBody";
import { ModuleListHeader } from "components/utils/moduleList/components/ModuleListHeader";
import { manufacturingPlansListConfig } from "components/utils/moduleList/utils/moduleListConfig";
import { NoResults } from "components/utils/noResults";
import { useQuery, useToggle } from "hooks";
import { useState } from "react";
import { handleMultipleRowsHighlight } from "utilities/handleMultipleRowsHighlight";
import { ListHeader } from "./components/ListHeader";
import { ListItem } from "./components/ListItem";
import { getSearch } from "./utils/getSearch";
import { useManufacturingPlans } from "api/manufacturingNew/hooks";
import { CreateManufacturingPlanModal } from "./components/CreateManufacturingPlanModal";
import { RouteComponentProps } from "react-router";
import { Tab } from "api/manufacturingNew/models";

export const ManufacturingPlansList = ({ match }: RouteComponentProps<{ tab: Tab }>) => {
  const { tab } = match.params;
  const { query } = useQuery({ exclude: ["panelId"] });
  const search = getSearch({ query, tab });
  const { data: manufacturingPlans, error, isLoading, pagination } = useManufacturingPlans(search);
  const createManufacturingPlanModal = useToggle(false);
  const [highlightedRows, setHighlightedRows] = useState<HighlightedRow[]>([]);

  const noResults = !manufacturingPlans.length && !isLoading && !error;

  if (error) {
    return (
      <div>
        <ListHeader open={createManufacturingPlanModal.open} />
        <div className="mt-4">
          <CommonError status={error._httpStatus_} />
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div>
        <Loader module="manufacturing" />
        <ListHeader open={createManufacturingPlanModal.open} />
      </div>
    );
  }

  const selectMutlipleItems = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    id: UUID | number,
    index: number,
    togglePanel: () => void,
  ) => {
    handleMultipleRowsHighlight(
      event,
      highlightedRows,
      id,
      index,
      setHighlightedRows,
      togglePanel,
      manufacturingPlans,
    );
  };

  return (
    <div className="pageContainer">
      <ListHeader open={createManufacturingPlanModal.open} />
      <RightPanelHandler name="manufacturingPlansList">
        {({ close, isActive, isHighlighted, togglePanel }) => (
          <ListDrawerWrapper>
            {noResults ? (
              <NoResults on={noResults} subHeader="zamówienia" />
            ) : (
              <ModuleList>
                <ModuleListHeader
                  gridStyle={manufacturingPlansListConfig.grid}
                  labels={manufacturingPlansListConfig.labels}
                />
                <ModuleListBody>
                  {manufacturingPlans.map((manufacturingPlan, index) => (
                    <ListItem
                      highlightedRows={highlightedRows}
                      index={index}
                      isActive={isActive}
                      isHighlighted={isHighlighted}
                      key={manufacturingPlan.id}
                      manufacturingPlan={manufacturingPlan}
                      selectMutlipleItems={selectMutlipleItems}
                      togglePanel={togglePanel}
                    />
                  ))}
                </ModuleListBody>
              </ModuleList>
            )}
            <RightPanel close={close} />
            <InvoicePagination pagination={pagination} />
          </ListDrawerWrapper>
        )}
      </RightPanelHandler>
      {createManufacturingPlanModal.isOpen && (
        <CreateManufacturingPlanModal close={createManufacturingPlanModal.close} />
      )}
    </div>
  );
};
